/**
 * index.js - Entry point for auth services
 * 
 * This file exports all auth-related services and utilities
 * to provide a clean public API for the auth module.
 */

import TokenService from './TokenService';
import TokenStorage from './TokenStorage';
import AuthError from './AuthError';
import { getDspEnvConfig } from '../../config/dspEnv';

// Export individual classes for direct import
export { TokenService, TokenStorage, AuthError };

// Create and export a singleton instance for app-wide use
const tokenService = new TokenService({
  apiKey: getDspEnvConfig().apiKey,
});

export default tokenService;
